import React, { useState, useEffect } from "react";
import "./instructionpop.css";
import HindiInstruction from "../hindi";
import EnglishInstruction from "../english";
import Kannda from "../kannda";
import Cross from "../../.././assets/icons/cross.png";
import { connect } from "react-redux";

const InstructionPopUp = (props) => {
  const [languageSelected, setLanguageSelected] = useState(1);
  useEffect(() => {
    const langFromRedux = props?.state?.languageSelected;
    const langFromStorage = parseInt(localStorage.getItem("preferred_language"));
  // console.log("langinst",langFromRedux,langFromStorage,languageSelected)
    if (langFromRedux) {
      setLanguageSelected(Number(langFromRedux));
    } else if (langFromStorage) {
      setLanguageSelected(langFromStorage);
    } else {
      setLanguageSelected(1); // default to English
    }
  }, [props?.state?.languageSelected]);
  
  
  return (
    <>
      <div className="popup-box" onClick={() => props.setShowInstruction()}>
        <div className="Instructionbox">
          <div style={{ display: "flex", flexDirection: "row-reverse" }}>
            <button onClick={() => props.setShowInstruction()}>
              <img src={Cross} />
            </button>
          </div>
          {!(languageSelected == 2 || languageSelected == 3) && (
            <EnglishInstruction
              instruction={
                props.state.test_data.instruction_content == null
                  ? atob(props.state.test_data.instruction_description).replace(
                      /(<([^>]+)>)/gi,
                      ""
                    )
                  : props.state.test_data.instruction_content[0].description
              }
            />
          )}
          {languageSelected == 2 && (
            <HindiInstruction
              instruction={
                props.state.test_data.instruction_content == null
                  ? atob(props.state.test_data.instruction_description).replace(
                      /(<([^>]+)>)/gi,
                      ""
                    )
                  : props.state.test_data.instruction_content[0].description
              }
            />
          )}
          {languageSelected == 3 && (
            <Kannda
              instruction={
                props.state.test_data.instruction_content == null
                  ? atob(props.state.test_data.instruction_description).replace(
                      /(<([^>]+)>)/gi,
                      ""
                    )
                  : props.state.test_data.instruction_content[0].description
              }
            />
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({ state: state });
export default connect(mapStateToProps)(InstructionPopUp);
